/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedGetProjectListDto } from '../../models/backend-paginated-get-project-list-dto';

export interface ProjectsExchangePublickProjectsList$Params {
  category__icontains?: string;
  duration__gte?: number;
  duration__lte?: number;
  irr__gte?: number;
  irr__lte?: number;

  /**
   * Фильтр по IRR
   */
  irr_range?: string;

  /**
   * Number of results to return per page.
   */
  limit?: number;
  npv__gte?: number;
  npv__lte?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;

  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;

  /**
   * Фильтр по периоду окупаемости
   */
  payback_range?: string;
  rating__gte?: number;
  rating__lte?: number;

  /**
   * Фильтр по Рейтингу
   */
  rating_range?: string;
  roe__gte?: number;
  roe__lte?: number;
  roi__gte?: number;
  roi__lte?: number;

  /**
   * A search term.
   */
  search?: string;
  start_date__gte?: string;
  start_date__lte?: string;
  years_to_payback__gte?: number;
  years_to_payback__lte?: number;
}

export function projectsExchangePublickProjectsList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsExchangePublickProjectsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedGetProjectListDto>> {
  const rb = new RequestBuilder(rootUrl, projectsExchangePublickProjectsList.PATH, 'get');
  if (params) {
    rb.query('category__icontains', params.category__icontains, {});
    rb.query('duration__gte', params.duration__gte, {});
    rb.query('duration__lte', params.duration__lte, {});
    rb.query('irr__gte', params.irr__gte, {});
    rb.query('irr__lte', params.irr__lte, {});
    rb.query('irr_range', params.irr_range, {});
    rb.query('limit', params.limit, {});
    rb.query('npv__gte', params.npv__gte, {});
    rb.query('npv__lte', params.npv__lte, {});
    rb.query('offset', params.offset, {});
    rb.query('ordering', params.ordering, {});
    rb.query('payback_range', params.payback_range, {});
    rb.query('rating__gte', params.rating__gte, {});
    rb.query('rating__lte', params.rating__lte, {});
    rb.query('rating_range', params.rating_range, {});
    rb.query('roe__gte', params.roe__gte, {});
    rb.query('roe__lte', params.roe__lte, {});
    rb.query('roi__gte', params.roi__gte, {});
    rb.query('roi__lte', params.roi__lte, {});
    rb.query('search', params.search, {});
    rb.query('start_date__gte', params.start_date__gte, {});
    rb.query('start_date__lte', params.start_date__lte, {});
    rb.query('years_to_payback__gte', params.years_to_payback__gte, {});
    rb.query('years_to_payback__lte', params.years_to_payback__lte, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedGetProjectListDto>;
    }),
  );
}

projectsExchangePublickProjectsList.PATH = '/api/projects/exchange/publick_projects/';
